<app-navbar></app-navbar>
<main>
  <app-sidebar></app-sidebar>
  <router-outlet></router-outlet>
</main>
<ng-container *ngIf="!soilguardFeatures">
  <app-footer></app-footer>
</ng-container>
<ng-container *ngIf="soilguardFeatures">
  <app-soilguard-footer></app-soilguard-footer>
</ng-container>